import { createFileRoute, useNavigate } from '@tanstack/react-router'
import {zodValidator} from '@tanstack/zod-adapter'
import { queryClient } from 'merchant-api'
import { OTPassword } from 'merchant-components'
import { z } from 'zod'

const booleanSearchParam = z.preprocess((value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true';
  }
}, z.boolean());

export const Route = createFileRoute('/(public)/login/otp')({
  validateSearch: zodValidator(z.object({
    key: z.string().trim().optional(),
    emailMasked: z.string().trim().optional(),
    redirect: z.string().trim().optional(),
    verifyEmailAddressTitle: booleanSearchParam.optional(),
  })),
  component: () => {
    const { key, emailMasked, redirect, verifyEmailAddressTitle } = Route.useSearch()
    const navigate = useNavigate();

    return (
      <OTPassword
        OTPKey={key}
        emailMasked={emailMasked}
        headingMessageId={verifyEmailAddressTitle ? 'proveBasicInfo.fallback.continue.email.pageTitle' : undefined}
        onVerify={() => {
          // The verify minted a new session: drop every cached query so nothing from the
          // previous identity (current application, offers, loan state) leaks into this one.
          queryClient.clear();
          navigate({ to: redirect || '/' });
        }}
      />
    )
  },
})

